// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows: SRP — standalone 404 page for invalid share links, etc.
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const NotFoundPage = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: '#ffffff',
      color: 'text.primary',
    }}
  >
    <Container maxWidth="sm">
      <Typography variant="h1" component="h1" sx={{ fontWeight: 700, color: 'primary.main' }}>
        404
      </Typography>
      <Typography variant="h5" gutterBottom sx={{ mt: 1 }}>
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary">
        This link is invalid, expired, or has already been used.
      </Typography>
    </Container>
  </Box>
);

export default NotFoundPage;
